export default [
  {
    id: 1,
    scene: 'Hospital',
    environment: 'models/environments/hospital.glb',
    title: 'Over het belang van wandelen',
    fragments: [
      {
        audio: 'audio/stories/01a.mp3',
        text: 'Hallo! Ik ben Wouter en ik zal u zo begeleiden tijdens een virtuele wandeling.\nAls u het scherm rechts uitklapt, dan kunt u de teksten meelezen als u dit fijn vindt.',
        position: 0.0,
        camera: {
          x: -12,
          y: 6,
          z: 21
        },
        intro: {
          position: -10.0,
          camera: {
            x: 4,
            y: 1,
            z: -1
          }
        }
      },
      {
        audio: 'audio/stories/01b.mp3',
        text: 'Tijdens deze wandeling probeer ik u aan het denken te zetten over wat u belangrijk vindt in deze fase van uw leven.\nVoordat we daarmee beginnen, leg ik u eerst uit waarom het zo belangrijk is dat u hier nu alvast over nadenkt.',
        position: 35.8,
        camera: {
          x: 24,
          y: 5,
          z: 8
        },
        intro: {
          position: -10.0,
          camera: {
            x: 12,
            y: 2,
            z: 2
          }
        }
      },
      {
        audio: 'audio/stories/01c.mp3',
        text: 'Uw eigen oncoloog heeft aangegeven dat hij of zij geen (geschikte) behandelopties meer voor u heeft. De oncoloog heeft u daarom doorverwezen naar een gespecialiseerd ziekenhuis of een gespecialiseerde collega in hetzelfde ziekenhuis.\nBinnenkort heeft u daar een afspraak om te bespreken wat de mogelijkheden voor u zijn om aan een studiebehandeling deel te nemen.',
        position: 80.6,
        camera: {
          x: 20,
          y: 2,
          z: -1
        },
        intro: {
          position: 34.8,
          camera: {
            x: 24,
            y: 5,
            z: 8
          }
        }
      },
      {
        audio: 'audio/stories/01d.mp3',
        text: 'Studiebehandelingen zijn studies naar nieuwe behandelingen die nog in ontwikkeling zijn. Er is nog geen hard bewijs dat patiënten zoals u hier voordeel van hebben.\nDeelname hieraan kan erg intensief zijn, omdat er extra onderzoeken en controlemomenten nodig zijn. Die extra onderzoeken zijn nodig om zoveel mogelijk over de studiebehandeling te leren en deze veilig te kunnen geven.\nHet is daarom nog belangrijker dan bij een gewone behandeling dat u een persoonlijke afweging maakt of u hieraan wilt deelnemen of niet.',
        position: 146.7,
        camera: {
          x: 35,
          y: 12,
          z: 42
        },
        intro: {
          position: 100.9,
          camera: {
            x: 0,
            y: 6,
            z: 45
          }
        }
      },
      {
        audio: 'audio/stories/01e.mp3',
        text: 'Tijdens uw afspraak zal de oncoloog de informatie met u bespreken die voor u relevant is.\nU zult uitleg krijgen over wat een studiebehandeling is, wat deelname aan een studiebehandeling voor u betekent en of u hiervoor in aanmerking kunt komen.',
        position: 248.6,
        camera: {
          x: 24,
          y: 5,
          z: 8
        },
        intro: {
          position: 202.8,
          camera: {
            x: -12,
            y: 2,
            z: 8
          }
        }
      },
      {
        audio: 'audio/stories/01f.mp3',
        text: 'Een belangrijk doel van het gesprek is ook dat u samen met de oncoloog goed op een rijtje zet wat voor u van waarde is.\nDaarom wil ik u nu alvast helpen nadenken over wat u belangrijk vindt in het leven. Dit is belangrijk voor het besluit om wel of niet mee te willen doen aan een studiebehandeling.\nZo bereidt u zich goed voor op de afspraak met de oncoloog.',
        position: 296.8,
        camera: {
          x: 26,
          y: -1,
          z: -2
        },
        intro: {
          position: 251.0,
          camera: {
            x: 22,
            y: 9,
            z: 12
          }
        }
      }
    ]
  },
  {
    id: 2,
    scene: 'Hospital',
    environment: 'models/environments/hospital.glb',
    title: 'Over hoe wandelen werkt',
    fragments: [
      {
        audio: 'audio/stories/02a.mp3',
        text: 'In deze wandeling maakt u kennis met vijf personages die zich in dezelfde situatie bevinden als u. Ze willen allemaal graag met u wandelen en u kunt er zelf voor kiezen om dat wel of niet te doen.\nOm ze beter te leren kennen kunt u ze eerst vragen om zich voor te stellen. Ze zullen dan in het kort vertellen wie zij zijn.\nDe personages die u kiest om mee te gaan wandelen, zullen hun verhalen met u delen. Ze zullen vertellen wat zij belangrijk vinden in het leven. Misschien vertellen ze dingen die u herkent, maar het kan ook zijn dat er dingen voorbijkomen waar u nog niet over hebt nagedacht.\nAls u een verhaal heeft beluisterd verschijnt er een vinkje bij.',
        position: 0.0,
        camera: {
          x: -12,
          y: 10,
          z: 25
        }
      },
      {
        audio: 'audio/stories/02b.mp3',
        text: 'Om te zorgen dat u een overzicht krijgt van wat u belangrijk vindt, kunt u tijdens de wandeling aantekeningen maken. Dit kunnen vragen zijn of algemene punten die u met de oncoloog zou willen bespreken. Het is daarom wel handig om pen en papier bij de hand te hebben voor u begint met wandelen!\nU kunt de wandeling pauzeren, zodat u makkelijk iets kunt opschrijven. Daarna kunt u weer verdergaan waar u gebleven bent.\nWe hopen dat u met alle notities een goed beeld krijgt van wat u waardevol vindt.',
        position: 129.1,
        camera: {
          x: 36,
          y: 14,
          z: 5
        }
      }
    ]
  },
  {
    id: 3,
    scene: 'Park',
    environment: 'models/environments/park1.glb',
    title: 'Over relaties met anderen',
    fragments: [
      {
        audio: 'audio/stories/03a.mp3',
        text: 'Wat ik het moeilijkst vind, is het effect van de ziekte op mijn leven. Ik had een druk sociaal leven en nu lijkt dit steeds minder te worden.\nHet is niet dat ik mijn vriendinnen niet meer zie, maar het wordt minder omdat het voor mij zo vermoeiend is. Zelfs een boek lezen is me te vermoeiend geworden.\nHerkent u dit?',
        position: 0.0,
        camera: {
          x: -27,
          y: 10,
          z: 14
        }
      },
      {
        audio: 'audio/stories/03b.mp3',
        text: 'Ik voel me steeds verder afgezonderd. Op sommige dagen is het contact met de thuiszorg het enige echte menselijke contact dat ik heb.\nIk heb tegen mijn vriendinnen gezegd dat ze gewoon zonder mij moeten afspreken, maar dat ik daardoor verder van de groep komt te staan doet wel pijn.\nVoornamelijk digitaal contact met je vriendinnen geeft weinig voldoening.',
        position: 64.4,
        camera: {
          x: -12,
          y: 16,
          z: 29
        }
      },
      {
        audio: 'audio/stories/03c.mp3',
        text: 'Mijn kinderen proberen zoveel mogelijk vrij te krijgen om mee te gaan naar het ziekenhuis. Ze willen niet dat ik alleen ga.\nHet is jammer dat mijn ziek zijn de aanleiding is dat ze zo vaak langs moeten komen, maar ze willen er echt voor me zijn en dan besef ik wat een fantastische kinderen ik heb.\nMaar zij blijven ook hoogstens een weekend of een dag. Daarna gaan ze ook weer terug naar hun eigen leven.',
        position: 137.2,
        camera: {
          x: -34,
          y: 0,
          z: 10
        }
      },
      {
        audio: 'audio/stories/03d.mp3',
        text: 'Omdat ik steeds afhankelijker ben van anderen voor zorg en vermaak, voel ik me ook steeds meer tot een last. Misschien is dit een onvermijdelijk onderdeel van het ziek zijn, maar ik weet niet hoe lang ik dit nog volhoud.\nIk zou met de arts willen bespreken welke optie past bij mijn situatie.\nHoe is het contact met uw sociale kring?',
        position: 210.9,
        camera: {
          x: 15,
          y: 8,
          z: 10
        }
      }
    ]
  },
  {
    id: 4,
    scene: 'Park',
    environment: 'models/environments/park2.glb',
    title: 'Over afhankelijkheid',
    fragments: [
      {
        audio: 'audio/stories/04a.mp3',
        text: 'Het huishouden doen vond ik nooit zo erg. Nu ik steeds minder kan, komt iemand dit voor mij doen.\nDat steekt wel, dat ik zoiets simpels als stofzuigen niet meer zelf kan. Dat ik zelf niet meer bepaal hoe het leven gaat, wat ik wel en niet kan doen is me inmiddels wel duidelijk geworden.\nOok als ik ergens heen wil, moet ik aan mijn kinderen, buren of vrienden vragen of ze willen helpen.\nHoe is dat voor u?',
        position: 0.0,
        camera: {
          x: -27,
          y: 10,
          z: 14
        }
      },
      {
        audio: 'audio/stories/04b.mp3',
        text: 'De afhankelijkheid van anderen vind ik vreselijk, vooral omdat het over dagelijkse dingen gaat, maar wat moet je anders?\nIk wil niet aan mijn buren of vriendinnen vragen of ze komen schoonmaken of om boodschappen voor me te doen, ook al hebben ze het wel aangeboden.\nAls de thuiszorg langskomt heb ik wel aanspraak en de vrouw die langskomt is ontzettend lief en attent.',
        position: 82.5,
        camera: {
          x: -12,
          y: 16,
          z: 29
        }
      },
      {
        audio: 'audio/stories/04c.mp3',
        text: 'Het liefst zou ik het allemaal weer zelf kunnen doen, maar de kans dat dat gaat gebeuren is klein. Ik hoop in ieder geval dat ze in het ziekenhuis waar ik nu heen ga iets hebben dat mijn kwaliteit van leven weer een stukje beter maakt.\nDe oude zal ik niet meer worden, maar dat ik zelf weer het één en ander kan doen zou het leven een stuk fijner maken.\nWat zou u verbeterd willen zien?',
        position: 154.4,
        camera: {
          x: -34,
          y: 0,
          z: 10
        }
      }
    ]
  },
  {
    id: 5,
    scene: 'Park',
    environment: 'models/environments/park3.glb',
    title: 'Over keuzes maken',
    fragments: [
      {
        audio: 'audio/stories/05a.mp3',
        text: 'Ik weet dat ik binnenkort keuzes moet gaan maken. Wat wil ik nog? Toch nog een keer een behandeling of toch niet?\nEigenlijk wil ik niet aan een studiebehandeling beginnen. Het is zo belastend qua tijd en energie en ik weet niet of het me iets van verbetering gaat brengen.\nIk heb al zoveel keuzes moeten maken de afgelopen twee jaar. Een testament, het verkopen van mijn nieuwe elektrische fiets, of ik nog een keer op vakantie kan gaan met de kinderen...',
        position: 0.0,
        camera: {
          x: -27,
          y: 10,
          z: 14
        }
      },
      {
        audio: 'audio/stories/05b.mp3',
        text: 'Ik probeer de kinderen te betrekken bij alles, want zij zijn toch degenen die achter blijven, niet? Zij zeggen steeds, "Ma, het is jouw leven en je moet doen wat voor jou goed voelt".\nMaar hoe kan ik nou een keuze maken die voor mij goed voelt als dat voor mijn kinderen misschien niet goed voelt?',
        position: 90.1,
        camera: {
          x: -12,
          y: 16,
          z: 29
        }
      },
      {
        audio: 'audio/stories/05c.mp3',
        text: 'Ze zeggen wel eens dat er geen goede of foute keuzes zijn, maar het voelt voor mij alsof er alleen maar foute keuzes zijn.\nNiemand kan me verder ook helpen bij het maken van een keuze, want ze zeggen allemaal hetzelfde: "Doe het voor jezelf!"\nMaar ik ben niet de enige! Als dat zo was, dan zou het misschien wel makkelijker zijn.\nWat zijn uw overwegingen?',
        position: 147.3,
        camera: {
          x: -34,
          y: 0,
          z: 10
        }
      },
      {
        audio: 'audio/stories/05d.mp3',
        text: 'Ik hoop dat er iemand mee gaat naar het ziekenhuis als we over deze keuze gaan praten.\nWie zou u willen meenemen?',
        position: 218.6,
        camera: {
          x: 15,
          y: 8,
          z: 10
        }
      }
    ]
  },
  {
    id: 6,
    scene: 'Forest',
    environment: 'models/environments/forest1.glb',
    title: 'Over relaties met anderen',
    fragments: [
      {
        audio: 'audio/stories/06a.mp3',
        text: 'Laatst zaten we op woensdagavond te kaarten, mijn gedachten sprongen de hele tijd heen en weer omdat ik pijn had.\nHet voelt vervelend om er dan zelf over te beginnen, dus ik had gehoopt dat iemand zou vragen hoe het met me gaat.\nZe vragen het wel altijd als ik die week in het ziekenhuis ben geweest, want dan zijn ze benieuwd of er nieuws is.',
        position: 0.0,
        camera: {
          x: -24,
          y: 12,
          z: 19
        }
      },
      {
        audio: 'audio/stories/06b.mp3',
        text: 'Maar soms lijkt het alsof mijn problemen er niet zijn.\nIk wil ook niet de hele avond opeisen met mijn problemen. Voor je het weet gaat het alleen over mij, terwijl ik ook vooral gewoon over andere zaken wil praten.\nMaar kort even mijn hart luchten is wel fijn. En dat het daarna juist eens niet over mij gaat.',
        position: 67.3,
        camera: {
          x: 3,
          y: 9,
          z: 36
        }
      },
      {
        audio: 'audio/stories/06c.mp3',
        text: 'Het voelt zo dubbel allemaal. Aan de ene kant wil je gezien worden als gewoon Hubert, aan de andere kant wil je ook dat mensen rekening met je houden.\nIk begrijp dat het lastig is, maar ik vind het ook moeilijk om aan te geven.\nHoe is dit voor u?',
        position: 125.7,
        camera: {
          x: -22,
          y: 26,
          z: 23
        }
      }
    ]
  },
  {
    id: 7,
    scene: 'Forest',
    environment: 'models/environments/forest2.glb',
    title: 'Over nog steeds genieten',
    fragments: [
      {
        audio: 'audio/stories/07a.mp3',
        text: 'Voorheen werkte ik in de bouw, zwaar fysiek werk.\nSinds ik gestopt ben met werken, moet ik toch proberen een beetje fit te blijven. Dus ik probeer een paar keer per week te wandelen, naar de supermarkt of met de kleinkinderen naar het park of speeltuintje.',
        position: 0.0,
        camera: {
          x: -24,
          y: 12,
          z: 19
        }
      },
      {
        audio: 'audio/stories/07b.mp3',
        text: 'Vooral het passen op de kleinkinderen, daar kan ik zo van genieten.\nIk heb wel minder energie dan vroeger, dus opa kan niet meer meehuppelen. Zij zijn nog te jong om echt te snappen dat opa niet meer zo goed mee kan. Die kleintjes groot zien worden is het mooiste wat er is. Alleen al daarom wil ik fit blijven.\nHoe belangrijk is fit zijn voor u?',
        position: 49.2,
        camera: {
          x: 3,
          y: 9,
          z: 36
        }
      },
      {
        audio: 'audio/stories/07c.mp3',
        text: 'Waar ik ook van geniet zijn onze vrijdagavonden in het jazzcafé. Een biertje en een sigaartje erbij, heerlijk!\nIk weet echt wel dat het niet goed voor me is, maar er is toch niet echt meer iets aan te doen.\nWaarom zou ik dan de dingen waar ik van geniet de deur uit doen? Ik kan het beter zo aangenaam mogelijk voor mezelf maken.\nWaar geniet u het meeste van?',
        position: 123.7,
        camera: {
          x: -22,
          y: 26,
          z: 23
        }
      }
    ]
  },
  {
    id: 8,
    scene: 'Forest',
    environment: 'models/environments/forest3.glb',
    title: 'Over kiezen voor studiebehandeling',
    fragments: [
      {
        audio: 'audio/stories/08a.mp3',
        text: 'Ik heb gehoord dat ik misschien wel in aanmerking kan komen voor een studiebehandeling.\nAls je meedoet aan zoiets, dan doe je het niet alleen voor jezelf, maar ook voor anderen. Met de resultaten van deze studies kunnen ze weer verder medicijnen ontwikkelen.',
        position: 0.0,
        camera: {
          x: -24,
          y: 12,
          z: 19
        }
      },
      {
        audio: 'audio/stories/08b.mp3',
        text: 'Nu ik ziek ben, denk ik ook vooral aan mijn kinderen en kleinkinderen. Als zij ooit ziek worden, dan hoop ik dat er tegen die tijd nieuwe medicijnen zijn die beter werken dan de medicijnen die ze nu hebben.\nHet zou mooi zijn als ik aan die ontwikkeling heb bijgedragen door zo\'n nieuw medicijn te testen.',
        position: 47.9,
        camera: {
          x: 3,
          y: 9,
          z: 36
        }
      },
      {
        audio: 'audio/stories/08c.mp3',
        text: 'Het enige waarom ik niet mee zou doen, is als er echt veel bijwerkingen zijn waar ik ziek van word. Dat vind ik een belangrijke voorwaarde, dat de bijwerkingen niet te heftig zijn.\nVan de vorige chemo\'s was ik ook al zo ziek, dat wil ik eigenlijk niet meer. Dat zal ik ook wel aan de oncoloog vragen. We wachten het af.\nWelke overweging vindt u het belangrijkst?',
        position: 108.1,
        camera: {
          x: -22,
          y: 26,
          z: 23
        }
      }
    ]
  },
  {
    id: 9,
    scene: 'City',
    environment: 'models/environments/city1.glb',
    title: 'Over mijn lichaam',
    fragments: [
      {
        audio: 'audio/stories/09a.mp3',
        text: 'Op mijn leeftijd komt het natuurlijk niet heel vaak voor dat je te horen krijgt dat je vergevorderde kanker hebt. Je hebt het zelf niet in de hand of zoiets je overkomt of niet.\nWat ik wel in eigen hand heb is mijn leefstijl. Die heb ik helemaal omgegooid nadat ik ziek werd.',
        position: 0.0,
        camera: {
          x: 11,
          y: 0,
          z: 7
        }
      },
      {
        audio: 'audio/stories/09b.mp3',
        text: 'Gelukkig voel ik me niet ziek. Ik ben ook nog lang blijven doorwerken, om me toch nuttig te voelen.\nMijn voedingspatroon is nu heel gezond, al zeg ik het zelf. Geen onnodige vette happen meer, en alcohol ben ik ook helemaal mee gestopt.\nAls ik nog wel eens met collega\'s of vrienden ga eten of borrelen, dan eet ik natuurlijk gewoon mee met de rest. Maar ik houd me zoveel mogelijk vast aan mijn nieuwe gewoonten.\nHoe is dat voor u?',
        position: 53.8,
        camera: {
          x: 19,
          y: 1,
          z: 20
        }
      },
      {
        audio: 'audio/stories/09c.mp3',
        text: 'Sporten deed ik altijd al veel. Ik merk wel dat ik aan kracht en conditie heb ingeleverd door al de chemo\'s, maar ik ben niet ontevreden.\nOf deze leefstijl gaat helpen bij het aanslaan van medicatie of bij het stabiliseren van de ziekte weet ik niet, maar dan heb ik het in ieder geval geprobeerd.\nZou dit voor u werken?',
        position: 137.4,
        camera: {
          x: 0,
          y: 1,
          z: 29
        }
      }
    ]
  },
  {
    id: 10,
    scene: 'City',
    environment: 'models/environments/city2.glb',
    title: 'Over hoop houden',
    fragments: [
      {
        audio: 'audio/stories/10a.mp3',
        text: 'Ik zoek vaak naar artikelen of nieuws over verschillende studies en naar nieuwe behandelopties. Wat ik heb is niet heel zeldzaam, dus er wordt gelukkig veel onderzoek naar gedaan.\nIk hoop dat er een medicijn is dat misschien wel aanslaat. Of dat nou in Nederland is of niet, maakt me niet uit. Desnoods ga ik ervoor naar Amerika.',
        position: 0.0,
        camera: {
          x: -28,
          y: 3,
          z: 16
        }
      },
      {
        audio: 'audio/stories/10b.mp3',
        text: 'Van nature ben ik een optimistische man, dus dat werkt ook wel in mijn voordeel nu ik in deze situatie zit. Ik moet positief blijven.\nHoe optimistisch bent u?',
        position: 66.1,
        camera: {
          x: -30,
          y: 14,
          z: 13
        }
      },
      {
        audio: 'audio/stories/10c.mp3',
        text: 'Wat ik ervan begrepen heb is dat ze tegenwoordig specifieke medicijnen hebben voor bepaalde soorten tumoren. De succeskans is daardoor een stuk groter dan wanneer je zomaar iets gaat testen.\nIk ga navragen hoe dat voor mij zit.',
        position: 100.6,
        camera: {
          x: -1,
          y: -1,
          z: 22
        }
      },
      {
        audio: 'audio/stories/10d.mp3',
        text: 'Ik heb het idee dat dit voor mij gaat werken, ik heb mijn lichaam optimaal voorbereid, zodat dat in ieder geval zo goed mogelijk meewerkt.\nAls ze mij een studiebehandeling mogen aanbieden, dan zal ik die met beide handen aangrijpen. Ik hoop dat ik uitgekozen wordt om mee te doen. Ik ben bereid al mijn tijd en energie ervoor te geven om het te laten slagen.\nHoe zou u dit aanpakken?',
        position: 147.8,
        camera: {
          x: 1,
          y: 3,
          z: 40
        }
      }
    ]
  },
  {
    id: 11,
    scene: 'City',
    environment: 'models/environments/city3.glb',
    title: 'Over afleiding',
    fragments: [
      {
        audio: 'audio/stories/11a.mp3',
        text: 'Ik doe er nu wel laconiek over, dat ik gezond aan het leven ben en hoop dat het beter wordt, maar mijn situatie is natuurlijk vreselijk.\nHet feit dat mijn leven nu al op zijn einde loopt beangstigt me heel erg. Vandaar dat ik er soms zo over praat, dat maakt het makkelijker om er mee om te gaan.',
        position: 0.0,
        camera: {
          x: -26,
          y: 3,
          z: 15
        }
      },
      {
        audio: 'audio/stories/11b.mp3',
        text: 'Gelukkig heb ik fantastische vrienden om me heen die ook regelmatig doen vergeten dat ik ziek ben en zorgen voor afleiding.\nIk ben inmiddels minder gaan werken. Normaal werk je tot je pensioen, maar het ziet er naar uit dat mijn "oude dag" nu al min of meer begonnen is.\nWaarom zou ik niet nu al beginnen met genieten van wat meer vrije tijd?\nWat zorgt bij u voor afleiding van het ziek zijn?',
        position: 57.8,
        camera: {
          x: -41,
          y: -1,
          z: 38
        }
      },
      {
        audio: 'audio/stories/11c.mp3',
        text: 'Nu ga ik echt dingen voor mezelf doen, vooral de leuke dingen, waar ik tot nu toe nog niet aan toegekomen ben.\nIk hoop dat mijn vrienden me daarbij willen vergezellen. Ook al hoop ik dat het nog heel lang mag duren voordat het zo ver is.\nHeeft u een "bucketlist"?',
        position: 134.9,
        camera: {
          x: -1,
          y: -1,
          z: 22
        }
      }
    ]
  },
  {
    id: 12,
    scene: 'Country',
    environment: 'models/environments/country1.glb',
    title: 'Over afhankelijkheid',
    fragments: [
      {
        audio: 'audio/stories/12a.mp3',
        text: 'Waar ik echt tegenop zie, is dat ik straks misschien wel steeds meer afhankelijk wordt van hulpmiddelen of zorg. Een rollator, of erger dat ik straks in zo\'n bed kom te liggen. Dat anderen mij zo zien, nee, zo wil ik niet eindigen.\nIk wil mijn bewegingsvrijheid niet verliezen. Altijd was ik gewend dat ik kon gaan en staan waar ik wil, en nu ziet het er naar uit dat zelfs autorijden straks niet meer gaat.\nHoe denkt u over afhankelijkheid?',
        position: 0.0,
        camera: {
          x: -16,
          y: 3,
          z: 14
        }
      },
      {
        audio: 'audio/stories/12b.mp3',
        text: 'Zodra ik een goede dag heb geeft dat me weer hoop. Hoop, dat er dus nog wel goede dagen zijn, en dat er misschien wel iets van verbetering mogelijk is met de juiste hulp en medicijnen.\nEn als dat kan, dan kan er misschien ook nog wel meer. Daar probeer ik me aan vast te houden. Nu opgeven, daar heeft niemand iets aan.',
        position: 85.8,
        camera: {
          x: -17,
          y: 13,
          z: 30
        }
      },
      {
        audio: 'audio/stories/12c.mp3',
        text: 'Ik hoop zo erg dat een oncoloog nog iets met mij kan. Vooral dat ik niet meer zo moe ben en een blokje om kan gaan.\nOp de momenten dat ik amper uit mijn stoel kom voel ik me geen volwaardig persoon meer. Ik hoop dat de oncoloog me weer als een mens kan laten voelen.\nHet maakt me niet uit wat het is, studiebehandeling of juist niet, dit is mijn diepste wens.\nWelke keuze zou u maken?',
        position: 150.8,
        camera: {
          x: -18,
          y: -1,
          z: 30
        }
      }
    ]
  },
  {
    id: 13,
    scene: 'Country',
    environment: 'models/environments/country2.glb',
    title: 'Over relaties met anderen',
    fragments: [
      {
        audio: 'audio/stories/13a.mp3',
        text: 'Toen we hierheen verhuisden zag ik wel eens de buurman op de racefiets stappen. Ik heb hem aangesproken en laten weten ook een keer mee te willen.\nHet werd echt een sociale activiteit. Aan het einde van de dag samen eten en gezelligheid. Dat vind ik zo fijn aan waar we wonen. Je moet ervan houden, maar dat ons-kent-ons geeft een ontzettend fijn gevoel. Er is altijd iemand in de buurt die je om hulp kunt vragen.\nHoe is dat met uw sociale kring?',
        position: 0.0,
        camera: {
          x: -25,
          y: 9,
          z: 8
        }
      },
      {
        audio: 'audio/stories/13b.mp3',
        text: 'Ook nu komen ze regelmatig langs. Een pan soep of gewoon voor een kop koffie. Zo ben je nooit alleen. Het doet me echt ontzettend goed dat ze door dik en dun voor me klaar staan. Iedereen weet ook wat er speelt.\nDus als er weer eens een buurtavondje is waar ik bij kan zijn, dan praat ik eerst iedereen bij en daarna is het tijd voor leuke dingen. We kunnen huilen en lachen met elkaar, dat is waar het om draait.\nHoe is dat bij u?',
        position: 89.3,
        camera: {
          x: -15,
          y: 11,
          z: 18
        }
      },
      {
        audio: 'audio/stories/13c.mp3',
        text: 'De hoop is nu dat ik lang genoeg erbij kan blijven, zodat ik de dochter van onze buren kan zien trouwen. Ze was als een eigen kind, zo goed kennen we haar.\nIk zal met de oncoloog bespreken of het mogelijk is om hierbij te kunnen zijn.',
        position: 177.5,
        camera: {
          x: -19,
          y: 18,
          z: 37
        }
      }
    ]
  },
  {
    id: 14,
    scene: 'Country',
    environment: 'models/environments/country3.glb',
    title: 'Over dingen vastleggen',
    fragments: [
      {
        audio: 'audio/stories/14a.mp3',
        text: 'Soms denk ik wel eens, het is mooi geweest. Ik heb een prachtig leven gehad waarin ik alles heb kunnen doen wat we wilden doen. Het enige wat er waarschijnlijk niet in zit is het samen echt oud worden.\nMaar ik heb het geaccepteerd.',
        position: 0.0,
        camera: {
          x: -23,
          y: 4,
          z: -12
        }
      },
      {
        audio: 'audio/stories/14b.mp3',
        text: 'Toen ik jaren geleden te horen kreeg dat ik ziek was, vond ik het heel moeilijk. Meteen heb ik een testament op laten maken en heb ik met de huisarts euthanasie besproken. Voor als ik echt hard achteruitga.\nIk wil niet eindigen in een bed met allemaal slangen uit mijn lichaam. Dat heb ik toen ook tegen de huisarts gezegd.\nHeeft u iets vast laten leggen toen u ziek werd?',
        position: 50.2,
        camera: {
          x: -17,
          y: 2,
          z: 14
        }
      },
      {
        audio: 'audio/stories/14c.mp3',
        text: 'Het gekke is, je bent bang om achteruit te gaan, maar je past je toch iedere keer weer aan.\nHet betekende voor mij dat ik het rustiger aan moest doen. Dit heeft me tijd gegeven om me met andere dingen bezig te houden.\nIk vond schilderen altijd heel leuk, dus dat heb ik een tijdje opgepakt. Nu heb ik daar ook te weinig energie voor helaas.\nWat heeft u moeten aanpassen?',
        position: 126.2,
        camera: {
          x: -25,
          y: 19,
          z: 46
        }
      }
    ]
  },
  {
    id: 15,
    scene: 'Beach',
    environment: 'models/environments/beach1.glb',
    title: 'Over tijdsbesteding',
    fragments: [
      {
        audio: 'audio/stories/15a.mp3',
        text: 'Ik weet het nog zo goed, de dag dat ik te horen kreeg dat ik kanker had. Het was echt alsof alles om me heen zwart werd.\nHet eerste wat ik dacht was "dit is het einde". Na een paar weken had ik de klap wel verwerkt, maar toch. Het is alsof je leven ineens tot stilstand wordt gebracht en je toekomstplannen in duigen vallen. Ik hoop natuurlijk dat ik ze misschien toch nog kan uitvoeren, maar ik ben bang van niet.\nHoe was dat bij u?',
        position: 0.0,
        camera: {
          x: -28,
          y: 8,
          z: -8
        }
      },
      {
        audio: 'audio/stories/15b.mp3',
        text: 'Nu richt ik me voornamelijk op het leven zoals het nu is. Ondanks dat ik ernstig ziek ben, voel ik me nog best wel goed.\nDat wil ik zoveel mogelijk vasthouden en ik zou ook zeker niet willen inleveren als ze in het ziekenhuis een nieuw medicijn kunnen aanbieden. Nu kan ik me nog inzetten thuis en vrijwilligerswerk blijven doen.',
        position: 90.5,
        camera: {
          x: -7,
          y: 3,
          z: 38
        }
      },
      {
        audio: 'audio/stories/15c.mp3',
        text: 'Als dat niet meer kan doordat ik veel bijwerkingen krijg of er geen tijd meer voor is, dan heb ik niks meer. Ik bedoel, kwaliteit van leven vind ik het belangrijkst.\nNu kan ik er ook nog voor de kinderen zijn. Zo lang het kan wil ik daar niet op inleveren.\nWaar wilt u niet op inleveren?',
        position: 154.9,
        camera: {
          x: -34,
          y: 8,
          z: 17
        }
      },
      {
        audio: 'audio/stories/15d.mp3',
        text: 'De tijd die ik nog heb en waarin ik nog goed mee kan, wil ik daarom alleen besteden aan dingen die ik belangrijk vind en aan mensen die me dierbaar zijn.\nDe rest is veel minder belangrijk geworden. Ik wil met de arts bespreken welke optie het beste bij mijn wensen past.\nWaar wilt u uw tijd nu aan besteden?',
        position: 212.8,
        camera: {
          x: -54,
          y: 15,
          z: 12
        }
      }
    ]
  },
  {
    id: 16,
    scene: 'Beach',
    environment: 'models/environments/beach2.glb',
    title: 'Over ziek zijn',
    fragments: [
      {
        audio: 'audio/stories/16a.mp3',
        text: 'Het klinkt heel raar, maar ik vind het nu niet zo erg meer als toen ik net te horen kreeg dat ik kanker heb. Ook al is het allemaal snel gegaan, ik heb het geaccepteerd en ben verder gegaan met mijn leven.',
        position: 0.0,
        camera: {
          x: -28,
          y: 8,
          z: -8
        }
      },
      {
        audio: 'audio/stories/16b.mp3',
        text: 'Ik kan wel veel energie stoppen in frustratie en verdriet, maar ik kan er toch niks aan veranderen.\nDaarnaast denk ik dat het lot bepaald heeft dat het zo heeft moeten zijn. Het is me helaas overkomen.\nMijn broer is gelukkig heel erg betrokken en hij heeft ook al aangeboden om te helpen als ik er straks niet meer ben. Nu kan ik mijn gezin met een gerust hart achterlaten.\nHoe wilt u het achterlaten?',
        position: 40.9,
        camera: {
          x: -7,
          y: 3,
          z: 38
        }
      },
      {
        audio: 'audio/stories/16c.mp3',
        text: 'Dat betekent niet dat ik me geen zorgen maak. Ik wil natuurlijk dat mijn kinderen goed terecht komen, nu, maar ook later, als ze op eigen benen moeten gaan staan.\nNu doe ik het meeste in huis en zorg ik voor de kinderen. Straks moet mijn man dat allemaal doen. Maar ik wil mijn gezin niet achterlaten.\nDaarom twijfel ik of ik toch niet nog een laatste poging moet doen om de ziekte aan te pakken. Ook al is het een studiebehandeling.\nWat zou deelname aan een studiebehandeling voor u betekenen?',
        position: 123.4,
        camera: {
          x: -34,
          y: 8,
          z: 17
        }
      }
    ]
  },
  {
    id: 17,
    scene: 'Beach',
    environment: 'models/environments/beach3.glb',
    title: 'Over geloof en spiritualiteit',
    fragments: [
      {
        audio: 'audio/stories/17a.mp3',
        text: 'Van huis uit heb ik een geloof meegekregen, maar we mochten van onze ouders zelf bepalen hoeveel we er mee wilden doen.\nIk beleef het geloof zelf anders dan mijn ouders, maar er zijn wel dingen die ik erg waardevol vind.',
        position: 0.0,
        camera: {
          x: -28,
          y: 8,
          z: -8
        }
      },
      {
        audio: 'audio/stories/17b.mp3',
        text: 'Nu haal ik er ook veel steun uit. Als ik er niet meer ben, dan is het niet definitief klaar. Er is meer dan alleen het leven op aarde. Die wetenschap zorgt ervoor dat ik iets rustiger ben, ook voor mijn familie.',
        position: 43.4,
        camera: {
          x: -7,
          y: 3,
          z: 38
        }
      },
      {
        audio: 'audio/stories/17c.mp3',
        text: 'Ik help graag bij activiteiten van de gemeenschap hier in de buurt. Zo ken ik ook de meeste van mijn vriendinnen. Zij halen ook weer veel steun uit het geloof, omdat mijn ziek zijn hen ook raakt. Zij moeten straks zonder mij verder.\nIk weet dat zij en ik in goede handen zijn, dat helpt wel met het verwerken.\nOp welke manieren speelt geloof of spiritualiteit bij u een rol?',
        position: 89.6,
        camera: {
          x: -34,
          y: 8,
          z: 17
        }
      }
    ]
  }
]
